import React from 'react'
import colors from '../../constants/colors'
import Flex from '../Flex'
import Icon from '../Icon'
import { AvatarProps } from './Avatar.types'

const Avatar: React.FC<AvatarProps> = ({
  icon,
  src,
  isBorder,
  shape = 'circle',
  size = 24,
  backgroundColor = 'black25',
  ...props
}) => {
  return (
    <Flex
      borderRadius={shape === 'circle' ? '50%' : '8px'}
      backgroundColor={backgroundColor}
      width={size}
      height={size}
      backgroundImage={`url(${src})`}
      backgroundPosition='center'
      backgroundSize='cover'
      backgroundRepeat='no-repeat'
      justifyContent='center'
      alignItems='center'
      border={isBorder && `solid 4px ${colors.white}`}
      boxShadow={isBorder && '0px 0px 8px rgba(0,0,0,0.08);'}
      {...props}
    >
      {!src && (icon || <Icon name='Profile-solid' color='black50' size={size - 24} />)}
    </Flex>
  )
}

export default Avatar
